<!-- 「更新が完了しました」等のメッセージを出力する -->
<template>
    <div id="overlay" >
        <div id="content_modal">
            <div style="padding:10px;text-align:center">
               <b> {{ DateSetting(clicked) }}</b>
            </div>
            <div v-for="(sentaku_row , i) in sentaku_list" v-bind:key="i" class="select_row">

                {{ TimeSetting(sentaku_row.jikantai_start) }}～{{ TimeSetting(sentaku_row.jikantai_end) }}&nbsp;&nbsp;あと&nbsp;{{ sentaku_row.teiin - sentaku_row.ninzu }}人<!--/{{ sentaku_row.teiin }}人-->

                <span v-if="mode != 'nologin' && mode != 'noinfo'">
                    <button v-if="sentaku_row.sentaku_flg == 0" class="btn btn-primary btn_confirm check_button" v-on:click="Check(i)">
                        選択
                    </button>
                    <button v-else-if="sentaku_row.sentaku_flg == 1" class="btn btn-secondary btn_confirm check_button" v-on:click="Check(i)">
                        取消
                    </button>
                </span>
            </div>

            <div style="text-align:center;padding:10px 0">
                <button  class="btn btn-secondary btn_confirm" style="width:150px;height:40px" v-on:click="Close()">閉じる</button>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting } from '../js/userdata.js'

// 親コンポーネント（UserPgShosai.vue）から送られてきた値
// clicked    ：選択した日付
// moshikomi  ：申し込める日時のリスト（選択した日付のもの）
// select_date：申し込むユーザーがすでに選択したもの
// mode       ：ログインしてるかどうか
const props = defineProps(["param"])
let clicked = props.param.clicked
let moshikomi = props.param.moshikomi
let select_date = props.param.select_date
let mode = props.param.mode


let sentaku_list = []

for(let m = 0;m<moshikomi.length;m++){

    let set_length = sentaku_list.length

    sentaku_list[set_length] = moshikomi[m]
    sentaku_list[set_length].sentaku_flg = 0

    // 選択フラグを付与する
    if(moshikomi[m].teiin > moshikomi[m].ninzu){

        sentaku_list[set_length].sentaku_flg = 0
    
        // 表示する日時に番号が存在する場合は選択済み（取り消し対象）
        if(select_date.length != 0){
            for(let d = 0;d < select_date.length;d++){
                if(select_date[d].bango == moshikomi[m].all_count){
                    sentaku_list[set_length].sentaku_flg = 1
                }
            }
        }
    }else{
        sentaku_list[set_length].sentaku_flg = 2

    }
    
}



/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])


// 選択・取消ボタン押下
let Check = function(i){
    // 選択した日時を送って閉じる
    emit('call',{cmd:'set',date:clicked,moshikomi:sentaku_list[i]})
}



// 選択・取消ボタン押下
let Close = function(){
    // 閉じる
    emit('call',{cmd:'close'})
}



/* 初期処理 */

</script>

<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:2;
    width: 90%;
    max-width:340px;
    text-align: left;
    padding: 0.5em;
  background:#fff;
  white-space: pre-line;
}
.check_button{
    width:50px
}
#content_modal button{
    height: 45px;
    width:60px;
    padding: 0;
}

.select_row{
    padding:10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
</style>